
import React from "react";
import { Button, Spinner } from "react-bootstrap";

interface RfqActionBarProps {
  currentStep: number;
  totalSteps: number;
  isSubmitting: boolean;
  onPrev: () => void;
  onNextOrSubmit: () => void;
}

export default function RfqActionBar({
  currentStep,
  totalSteps,
  isSubmitting,
  onPrev,
  onNextOrSubmit,
}: RfqActionBarProps) {
  return (
    <div className="sticky-actions">
      <div className="sticky-actions-inner">
        <Button className="btn-aida" disabled={currentStep === 1} onClick={onPrev}>
          ← Précédent
        </Button>

        <Button className="btn-aida" onClick={onNextOrSubmit} disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              Traitement...
            </>
          ) : currentStep === totalSteps ? (
            "Publier"
          ) : (
            "Suivant →"
          )}
        </Button>
      </div>
    </div>
  );
}
